import { create } from "zustand";
import { useI18nStore } from "./i18n.store";

const defaultSelectedColumns = [
    "loan_id",
    "company",
    "create_date",
    "loan_from",
    "loan_to",
    "current_state",
    "sent_pieces",
    "returned_pieces",
];

export const useLoansTableStore = create((set) => {
    return {
        selectedColumns: [...defaultSelectedColumns],
        getAvailableColumns: () => {
            const t = useI18nStore.getState().t;
            return {
                "loan_id": "ID",
                "company": t("loans.customer"),
                "create_date": t("loans.requestDate"),
                "loan_from": t("loans.loanFrom"),
                "loan_to": t("loans.loanTo"),
                "current_state": t("common.state"),
                "sent_pieces": t("loans.sentPieces"),
                "returned_pieces": t("loans.returnedPieces"),
            };
        },
        toggleColumn: (key) =>
            set((state) => ({
                selectedColumns: state.selectedColumns.includes(key)
                    ? state.selectedColumns.filter((col) => col !== key)
                    : [...state.selectedColumns, key],
            })),
    };
});